$(document).ready(function() {
  const $form = $('#project-search');

  if ($form.length === 0) {
    return;
  };

  [
    $('#q_projects_product_category_id_eq'),
    $('#q_projects_category_id_eq'),
    $('#q_finance_needs_id_eq'),
    $('#q_badges_id_eq'),
    $('#q_status_matches_any_published'),
    $('#q_status_matches_any_succeeded'),
    $('#q_status_matches_any_closed'),
    $('#q_status_matches_any_reimbursed')
  ].forEach(filter => {
    filter.on('change', e => {
      e.preventDefault();
      submitForm($form);
    });
  })

  const submitForm = (form) => {
    $.ajax({
      url: form.attr('action'),
      type: 'GET',
      data: form.serialize()
    });
  }
})
